<template>
  <div>
    <vs-popup class="user-edit-popup"
              id="popup"
              title="UPDATE BUDGET"
              @close="open = false"
              :active.sync="open"
              :buttons-hidden="true">
      <vx-card no-shadow >
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form autocomplete="off">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="customers" name="customers" rules="required"
                                    v-slot="{ errors }">
                  <small class="label">Customer</small>
                  <vs-input readonly class="w-full" name="value" type="text" v-model="customer_data.company_name"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="time_interval" name="time_interval" rules="required"
                                    v-slot="{ errors }">
                  <small class="label">Time Interval</small>
                  <vs-input readonly class="w-full" name="time_interval" type="text" value="Monthly"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="unit" name="unit" rules="required"
                                    v-slot="{ errors }">
                  <small class="label">Unit</small>
                  <vs-input readonly class="w-full" name="unit" type="text" value="Kg"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3" v-for="(tool, index_tool) in budget_tools" :key="index_tool">
              <div class="vx-col w-full">
                <vx-card :card-border="true" :collapseAction="true">
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-1/3 w-full md:mb-0">
                      <ValidationProvider vid="formulations" name="formulations"
                                          v-slot="{ errors }">
                        <small class="label mb-2">Finished Product</small>
                        <vs-input v-if="!tool.new" readonly class="w-full" name="value" type="text" v-model="tool.formulation_code"/>
                        <v-select v-else :clearable="false" name="formulations" placeholder="" label="formulation_code"
                                  v-model="tool.formulation_id"
                                  :options="formulations"
                                  :reduce="option => option.id"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        />
                        <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <div class="vx-col md:w-1/3 w-full md:mb-0">

                      <small class="label mb-2">Financial Year</small>
                      <v-select :clearable="false" name="financial_year" placeholder="" label="value"
                                v-model="financial_year[index_tool]"
                                :options="f_y_arr"
                                :reduce="option => option.key"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      />

                    </div>
                    <div class="vx-col md:w-1/3 w-full md:mb-0 mt-4">
                      <vs-button v-if="getItems(tool.items, financial_year[index_tool]).length <= 1" color="success"
                                 class="ml-auto mt-3" @click="addInitialItems(index_tool)">
                        <small>Create Budget Tool</small>
                      </vs-button>
                      <!--                      <vs-button v-else @click.stop="onClickUpdateBudget(index_tool)" color="warning" class="ml-auto mt-2">-->
                      <!--                        Update Forecast-->
                      <!--                      </vs-button>-->
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <vx-card subtitle="Items" :id="`forecast_tool_card_${index_tool}`">
                        <table class="full-page-bg-color" border="0">
                          <thead>
                          <tr>
                            <th width="35%" class="head text-center">Period (Monthly)</th>
                            <th width="35%" class="head text-center">Value (Kg)</th>
                            <th width="30%" class="head text-center">Amount (GBP)</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="vs-con-loading__container" style="cursor: pointer; z-index: 100" :key="index_item" :id="`item_${index_tool}_${index_item}`"
                              v-for="(item, index_item) in getItems(tool.items, financial_year[index_tool])">
                            <td>
                              <ValidationProvider :vid="`${index_tool}${index_item}date`" :name="`${index_tool}${index_item}date`"
                                                  v-slot="{ errors }" rules="required">
                                <flat-pickr disabled class="w-full" :config="flatPkrConfig" v-model="item.date" placeholder="Choose Date" />
                                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                              </ValidationProvider>
                            </td>
                            <td>
                              <ValidationProvider :vid="`${index_tool}${index_item}value`" :name="`${index_tool}${index_item}value`" rules="required"
                                                  v-slot="{ errors }">
                                <vs-input class="w-full" name="value" type="text" v-model="item.value" @change="updateValue(index_tool,index_item)"
                                          @keyup.enter="enterValue(index_tool, index_item)" :id="`value_${index_tool}_${index_item}`"
                                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                              </ValidationProvider>
                            </td>
                            <td>
                              <ValidationProvider :vid="`${index_tool}${index_item}amount`" :name="`${index_tool}${index_item}amount`" rules="required"
                                                  v-slot="{ errors }">
                                <vs-input class="w-full" name="amount" type="text" v-model="item.amount" @change="updateValue(index_tool,index_item)"
                                          @keyup.enter="enterAmount(index_tool, index_item)" :id="`amount_${index_tool}_${index_item}`"
                                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                              </ValidationProvider>
                            </td>
                          </tr>
                          </tbody>
                        </table>

                      </vx-card>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>

            <div class="flex flex-wrap items-center justify-end mt-8">
              <vs-button class="ml-auto mt-2" @click="addNewProduct">Add New Product</vs-button>
            </div>

          </form>
        </ValidationObserver>
      </vx-card>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from '@/mixins/ErrorMessages'
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import moment from "moment/moment";

const FormulationsRepository = RepositoryFactory.get('formulations')
const CustomerRepository = RepositoryFactory.get('customer')
const SettingsRepository = RepositoryFactory.get('settings');
const BudgetToolRepository = RepositoryFactory.get('budget_tool');

function initialState() {
  return {
    open: false,
    time_interval: null,
    unit: null,
    formulation_code: null,
    customer_name: null,
    items: [],
    formulations: [],
    customers: [],
    customer_data: {
      company_name: '',
      id: ''
    },
    budget_tools: [],
    budget_configs: {
      config_time_interval: 'month',
    },
    financial_year: [
      moment().year() + ''
    ],
    f_y_arr: [
      { key: '2020', value: '2020/2021' },
      { key: '2021', value: '2021/2022' },
      { key: '2022', value: '2022/2023' },
      { key: '2023', value: '2023/2024' },
      { key: '2024', value: '2024/2025' },
      { key: '2025', value: '2025/2026' },
      { key: '2026', value: '2026/2027' },
    ],
    month_map: {
        "January": 1, "February": 2, "March": 3, "April": 4,
        "May": 5, "June": 6, "July": 7, "August": 8,
        "September": 9, "October": 10, "November": 11, "December": 12
    }
  }
}

export default {
  name: "UpdateBudgetTool",
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  methods: {
    async openPopup(customer_data) {
      await Object.assign(this.$data, initialState());
      this.$refs.form.reset()
      this.items = []
      this.customer_data = customer_data
      await this.fetchSettings()
      await this.fetchBudgetTool()
      await this.fetchFormulations()
      this.open = true
    },
    async fetchFormulations() {
      this.$vs.loading();
      const {data} = await FormulationsRepository.getListOfFormulationNoPagination(0)
      this.formulations = data.data
      this.$vs.loading.close()
    },
    async fetchBudgetTool(){
      this.$vs.loading();
      const { data } = (await BudgetToolRepository.getBudgetToolList(`customer_id=${this.customer_data.id}`)).data
      if(data.length === 0){
        await this.createBudget()
      }else {
        this.budget_tools = data[0].budget_tools
        this.budget_tools.map((tool, index) => {
          this.financial_year[index] = tool.items[0].financial_year.toString()
        })
      }
      this.$vs.loading.close()
    },

    async createBudget() {
      await this.addNewProduct()
    },
    async addInitialItems(index = 0)
    {
      if(this.budget_tools[index].formulation_id === ""){
        this.showErrorMessage("Select Finished product")
      }else{
        await this.setFirstDate(index, this.budget_tools[index].items.length)
        const rounds = this.budget_configs.config_time_interval === 'week' ? 52 : 12
        for (let i = 1; i < rounds; i++) {
          this.addNewItem(index)
        }
        await this.onClickUpdateBudget(index)
      }
    },

    addNewItem(index, value = 0, amount = 0){
      const items_length = this.budget_tools[index].items.length
      let nextDate = ''
      if(items_length >= 1){
        const date = this.budget_tools[index].items[items_length - 1].date
        nextDate = moment(date,'DD/MM/YYYY').add(1,  this.budget_configs.config_time_interval).format('DD/MM/YYYY')
      }
      this.budget_tools[index].items.push({ date: nextDate, value: value , amount: parseFloat(amount).toFixed(2) , financial_year: this.financial_year[index] })
    },

    async setFirstDate(tool_index = 0, item_index = 0){
      this.budget_tools[tool_index].items.push({
        date: '',
        value: '',
        amount: '',
        financial_year:''
      })
      this.budget_tools[tool_index].items[item_index].date = `01/${moment(this.financial_year_start_month, 'MMMM').format('MM')}/${this.financial_year[tool_index]}`
      this.budget_tools[tool_index].items[item_index].value = 0
      this.budget_tools[tool_index].items[item_index].amount = parseFloat(0).toFixed(2)
      this.budget_tools[tool_index].items[item_index].financial_year = this.financial_year[tool_index];
    },

    async addNewProduct() {
      this.budget_tools.push(
        {
          new:true,
          formulation_id: '',
          items: []
        }
      )
      this.financial_year[this.budget_tools.length - 1] = moment().year() + ''
    },
    updateValue(index_tool,index_item){
      this.updateItemValue(this,index_tool,index_item)
    },
    updateItemValue: _.debounce((vm,tool_index,index_item) => {
      vm.onClickUpdateBudget(tool_index,index_item)
    },50),
    enterValue(index_tool, index_item) {
      if(this.budget_tools[index_tool].items.length - 1 > index_item) {
        document.getElementById(`value_${index_tool}_${index_item + 1}`).focus();
        document.getElementById(`value_${index_tool}_${index_item + 1}`).select();
      }
    },
    enterAmount(index_tool, index_item) {
      if(this.budget_tools[index_tool].items.length - 1 > index_item) {
        document.getElementById(`amount_${index_tool}_${index_item + 1}`).focus();
        document.getElementById(`amount_${index_tool}_${index_item + 1}`).select();
      }
    },
    async fetchSettings() {
      this.$vs.loading();
      this.financial_year_start_month = (await SettingsRepository.getTheItem('financial_year_start_month')).data.data.financial_year_start_month;
      this.forecast_tool_time_interval = (await SettingsRepository.getTheItem('sales_marketing_tool_time_interval')).data.data.sales_marketing_tool_time_interval;
      if(this.forecast_tool_time_interval && this.forecast_tool_time_interval !== ''){
        if(this.forecast_tool_time_interval === 'monthly'){
          this.budget_configs.config_time_interval = 'months'
        }
        if(this.forecast_tool_time_interval === 'weekly') {
          this.budget_configs.config_time_interval = 'week'
        }
        if(this.forecast_tool_time_interval === 'daily') {
          this.budget_configs.config_time_interval = 'day'
        }
      }
      this.$vs.loading.close()
    },

    removeCard(index) {
      this.items.splice(index, 1)
    },
    onClickRemoveItem(index_tool, index_item) {
      this.budget_tools[index_tool].items.splice(index_item, 1)
    },
    checkDate(item_index){
      let validation = ''
      this.items.map((item, index) => {
        if (index !== item_index) {
          if (this.items[index].date === this.items[item_index].date) {
            validation = `unique_date:${this.items[index].date}`
          }
        }
      })
      return validation;
    },
    async onClickUpdateBudget(index, index_item = 0) {
      const vue = this
      this.$refs.form.reset();
      const validated = await this.$refs.form.validate().then((x) =>{
        return x
      })
      if(validated) {
        if(this.budget_tools[index].new){
          await this.$vs.loading()
          try {
            const payload = {
              customer_id: this.customer_data.id,
              budget_tools: this.budget_tools.filter((tool) => tool.new && tool.new === true)
            }
            await BudgetToolRepository.createBudgetTool(payload)
            this.showSuccessMessage('Budget tool created successfully');
            await this.fetchBudgetTool()
            await vue.$parent.refreshData()
            this.$vs.loading.close()
          }catch (error){
            this.$vs.loading.close()
            this.budget_tools[index].items = []
            this.convertAndNotifyError(error)
          }
        }else {
          // await this.$vs.loading({
          //   container: index_item ? `#item_${index}_${index_item}`: `#forecast_tool_card_${index}`,
          //   scale: 0.45
          // })
          try {
            const vue = this
            const payload = {
              items: this.budget_tools[index].items.map((x) => ({
                date: x.date,
                value: x.value,
                amount: parseFloat(x.amount).toFixed(2),
                financial_year: x.financial_year
              }))
            }
            await BudgetToolRepository.updateBudgetTool(this.budget_tools[index].id, payload)
          } catch (error) {
            // this.$vs.loading.close(index_item ?`#item_${index}_${index_item} > .con-vs-loading`:  `#forecast_tool_card_${index} > .con-vs-loading`)
            this.convertAndNotifyError(error)
          }
        }
        // this.$vs.loading.close(index_item ?`#item_${index}_${index_item} > .con-vs-loading`:  `#forecast_tool_card_${index} > .con-vs-loading`)
      }
    },
    getItems(items, financial_year) {
      const startMonth = this.month_map[this.financial_year_start_month];
      const startYear = parseInt(financial_year);
      const endMonth = startMonth === 1 ? 12 : startMonth - 1;
      const endYear = startMonth === 1 ? startYear : startYear + 1;

      // return items.filter((item )=> item.financial_year.toString() === financial_year )
      return items.filter(item => {
          const [day, month, year] = item.date.split('/').map(Number);
          if (year > startYear && year < endYear) {
              return true;
          }
          if (year === startYear && month >= startMonth) {
              return true;
          }
          if (year === endYear && month <= endMonth) {
              return true;
          }
          return false;
      });
    }
  },
  computed:{
    flatPkrConfig(){
      const interval = this.time_interval
      return {
        dateFormat: 'd/m/Y',
        plugins: [
          new monthSelectPlugin({
            shorthand: true,
            dateFormat: "d/m/Y",
          })
        ],
        enable: [
          function (date) {
            if (interval === 'monthly') {
              return (date.getDate() === 1)
            }
            if (interval === 'weekly') {
              return (date.getDay() === 1)
            }
            return true
          }
        ]
      };
    }
  },
}
</script>

<style scoped>
.user-edit-popup >>> .vs-popup {
  width: 40%;
}

table {
  border-collapse: collapse;
  width: 100%;
}

td, th {
  text-align: left;
  padding: 8px;
}
</style>
